module.exports = __webpack_public_path__ + "img/5-1.47a22387.svg";